import React from "react";
import InventoryRouter from "../router/inventory.js";

const InventoryLayout = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <InventoryRouter />
    </div>
  );
};

export default InventoryLayout;
